import Button from '@components/Button';
import Icon, { type IconName } from '@components/Icon';
import { cssJoin } from '@shared/util';
import { useAnchoredPopover } from '@volvo-cars/react-headless';

import PopoverButtonOptionItem from './PopoverButtonOptionItem';

export interface IOption {
  label: string;
  icon?: IconName;
  disabled?: boolean;
  onClick?: () => void;
}

interface Props {
  label: string;
  options: IOption[];
  disabled?: boolean;
}

const PopoverButton: IComponent<Props> = ({ label, disabled, options }) => {
  const { anchorProps, popoverProps, isOpen, hidePopover, togglePopover } =
    useAnchoredPopover({ placement: 'bottom-end' });

  return (
    <div>
      <Button
        size="small"
        variant="outlined"
        disabled={disabled}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={togglePopover}
        endIcon={
          <Icon
            icon="chevron-down"
            size={12}
            style={{
              transition: 'transform 150ms ease',
              transform: isOpen ? 'rotate(180deg)' : undefined,
            }}
          />
        }
        {...anchorProps}
      >
        {label}
      </Button>
      <ul
        {...popoverProps}
        role="menu"
        style={{ ...popoverProps.style, minWidth: '6.5rem' }}
        className={cssJoin('font-14', 'popover', 'shadow-sm', 'font-medium')}
      >
        {options.map((option) => (
          <PopoverButtonOptionItem
            key={option.label}
            option={option}
            onSelect={hidePopover}
          />
        ))}
      </ul>
    </div>
  );
};

export default PopoverButton;
